/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const CircleFastForward = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 19 19">
      <g>
        <path d="M9.5,1 C4.813,1 1,4.813 1,9.5 C1,14.187 4.813,18 9.5,18 C14.187,18 18,14.187 18,9.5 C18,4.813 14.187,1 9.5,1 M9.5,19 C4.262,19 0,14.738 0,9.5 C0,4.262 4.262,0 9.5,0 C14.738,0 19,4.262 19,9.5 C19,14.738 14.738,19 9.5,19" />
        <path d="M9.6113,13 C9.4623,13 9.3133,12.933 9.2153,12.806 C9.0473,12.587 9.0873,12.272 9.3053,12.104 L12.6813,9.5 L9.3053,6.896 C9.0873,6.728 9.0473,6.413 9.2153,6.194 C9.3833,5.977 9.7013,5.937 9.9173,6.104 L13.8053,9.104 C13.9273,9.199 14.0003,9.345 14.0003,9.5 C14.0003,9.655 13.9273,9.801 13.8053,9.896 L9.9173,12.896 C9.8263,12.966 9.7183,13 9.6113,13" />
        <path d="M6.5,13 C6.351,13 6.202,12.933 6.104,12.806 C5.936,12.587 5.976,12.272 6.194,12.104 L9.57,9.5 L6.194,6.896 C5.976,6.728 5.936,6.413 6.104,6.194 C6.273,5.977 6.59,5.937 6.806,6.104 L10.694,9.104 C10.816,9.199 10.889,9.345 10.889,9.5 C10.889,9.655 10.816,9.801 10.694,9.896 L6.806,12.896 C6.715,12.966 6.607,13 6.5,13" />
      </g>
    </BaseSvgIcon>
  )
}

export default CircleFastForward
